export default __webpack_public_path__ + "static/media/R5C_8114.1223a30a.jpg";